export enum CardType {
  Ewic = 'EWIC',
  Ebtcash = 'EBTCASH',
  Ebtfoodstamp = 'EBTFOODSTAMP',
  GiftCard = 'GIFTCARD',
}
